import styled from 'styled-components'

export const CardWrapper = styled.div`
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: translateY(-2px);
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`

export const TruncatedTitle = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  flex: 1;
  margin-right: 8px;
`

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  gap: 0.5rem;

  @media (max-width: 768px) {
    gap: 0.25rem;
  }

  &:last-child {
    margin-bottom: 0;
  }
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 0.5rem;

  @media (max-width: 768px) {
    flex: 1;
    min-width: 60px;
    gap: 0.25rem;
  }
`

export const InfoLabel = styled.span`
  font-size: 1.125rem;
  color: #666;
  font-weight: 500;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  &::after {
    content: ':';
  }
`

export const InfoValue = styled.span`
  font-size: 1.125rem;
  color: #333;
  font-weight: 400;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`

export const ActionButton = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  @media (max-width: 768px) {
    margin-left: 0.25rem;
  }
`

export const ActionButtonRow = styled.div`
  display: flex;
  width: 100%;
  margin-top: 0.5rem;

  button {
    width: 100%;
  }
`

export const ProductDescription = styled.div`
  font-size: 1.125rem;
  color: rgba(0, 0, 0, 0.7);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`
